/**
 * Spells/traps that stay on the field for a fixed number of turns and show a
 * turn counter on the card. The lock/effect still lives on engine state (e.g.
 * `attackLockTurns`); `CardInstance.turnCounter` is the remaining display
 * value and the expiry clock.
 *
 * Tick rule is per card: Swords of Revealing Light counts three of the
 * opponent's turns (LOB-era), so it decrements when that seat ends a turn.
 */

export type LingeringTickOn = 'controller' | 'opponent';

export interface LingeringTurnSpec {
  /** How many of the tick-seat's turns the card stays. */
  turns: number;
  /** Whose turn end decrements the counter. */
  tickOn: LingeringTickOn;
}

/** Official passcodes → lingering-turn spec. Add new cards here. */
export const LINGERING_TURN_CARDS: Record<string, LingeringTurnSpec> = {
  // Swords of Revealing Light: 3 of the opponent's turns.
  '72302403': { turns: 3, tickOn: 'opponent' },
};

export function lingeringSpecFor(cardId: string): LingeringTurnSpec | undefined {
  return LINGERING_TURN_CARDS[String(cardId)];
}

/** Starting duration for the activation overlay count-up, if any. */
export function lingeringTurnsFor(cardId: string): number | undefined {
  return lingeringSpecFor(cardId)?.turns;
}
